import React, { useState } from 'react';
import './PlanCuentasTree.css';

const TIPO_BADGES = {
  'ACTIVO': { cls: 'badge-activo', label: 'ACT' },
  'PASIVO': { cls: 'badge-pasivo', label: 'PAS' },
  'PATRIMONIO': { cls: 'badge-patrimonio', label: 'PAT' },
  'INGRESO': { cls: 'badge-ingreso', label: 'ING' },
  'GASTO': { cls: 'badge-gasto', label: 'GAS' },
};

const PlanCuentasTreeNode = ({ node, onCreateChild, onEdit, onDelete, level = 0 }) => {
  const [isExpanded, setIsExpanded] = useState(level < 2);
  const hasChildren = node.children && node.children.length > 0;
  const badge = TIPO_BADGES[node.tipo_cuenta] || { cls: 'badge-default', label: '?' };
  const indent = level * 1.5;

  return (
    <div className="pct-node">
      <div
        className={`pct-row${level === 0 ? ' pct-row-root' : ''}${node.imputa ? ' pct-row-imputa' : ''}`}
        style={{ paddingLeft: `${0.75 + indent}rem` }}
      >
        {/* Expand / indent */}
        <button
          className={`pct-toggle${hasChildren ? '' : ' pct-toggle-hidden'}`}
          onClick={() => hasChildren && setIsExpanded(!isExpanded)}
          tabIndex={hasChildren ? 0 : -1}
        >
          {hasChildren ? (isExpanded ? '▾' : '▸') : ''}
        </button>

        {/* Badge tipo */}
        <span className={`pct-badge ${badge.cls}`} title={node.tipo_cuenta}>
          {badge.label}
        </span>

        {/* Codigo + Nombre */}
        <span className="pct-codigo">{node.codigo_completo || node.codigo}</span>
        <span className="pct-nombre">
          {node.nombre}
          {node.imputa && <span className="pct-imputa-tag">Imputa</span>}
          {node.descripcion && <span className="pct-desc-icon" title={node.descripcion}>i</span>}
        </span>

        {/* Actions */}
        <span className="pct-actions">
          {node.puede_tener_hijos && (
            <button className="pct-btn pct-btn-add" onClick={() => onCreateChild(node)} title="Agregar cuenta hija">+</button>
          )}
          <button className="pct-btn pct-btn-edit" onClick={() => onEdit(node)} title="Editar">&#9998;</button>
          <button className="pct-btn pct-btn-del" onClick={() => onDelete(node)} title="Eliminar">&times;</button>
        </span>
      </div>

      {hasChildren && isExpanded && (
        <div className="pct-children">
          {node.children.map((child) => (
            <PlanCuentasTreeNode
              key={child.id}
              node={child}
              onCreateChild={onCreateChild}
              onEdit={onEdit}
              onDelete={onDelete}
              level={level + 1}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const PlanCuentasTree = ({ tree, onCreateChild, onEdit, onDelete, viewMode }) => {
  if (viewMode === 'list') {
    const flattenTree = (nodes, result = []) => {
      nodes.forEach(node => {
        result.push(node);
        if (node.children && node.children.length > 0) {
          flattenTree(node.children, result);
        }
      });
      return result;
    };

    const flatList = flattenTree(tree);

    return (
      <div className="plan-cuentas-table">
        <table>
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Codigo</th>
              <th>Nombre</th>
              <th>Nivel</th>
              <th>Imputable</th>
              <th>Activo</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {flatList.map((cuenta) => {
              const b = TIPO_BADGES[cuenta.tipo_cuenta] || { cls: 'badge-default', label: cuenta.tipo_cuenta };
              return (
                <tr key={cuenta.id}>
                  <td><span className={`tipo-badge-table ${b.cls}`}>{b.label}</span></td>
                  <td className="codigo-cell">{cuenta.codigo_completo || cuenta.codigo}</td>
                  <td className="nombre-cell">{cuenta.nombre}</td>
                  <td className="nivel-cell">Nivel {cuenta.nivel_actual}</td>
                  <td className="imputable-cell">
                    <span className={`status-badge ${cuenta.imputa ? 'status-yes' : 'status-no'}`}>
                      {cuenta.imputa ? 'Si' : 'No'}
                    </span>
                  </td>
                  <td className="activo-cell">
                    <span className={`status-badge ${cuenta.activo ? 'status-active' : 'status-inactive'}`}>
                      {cuenta.activo ? 'Activa' : 'Inactiva'}
                    </span>
                  </td>
                  <td className="acciones-cell">
                    {cuenta.puede_tener_hijos && (
                      <button className="action-btn-table btn-add" onClick={() => onCreateChild(cuenta)} title="Agregar cuenta hija">+</button>
                    )}
                    <button className="action-btn-table btn-edit" onClick={() => onEdit(cuenta)} title="Editar">&#9998;</button>
                    <button className="action-btn-table btn-del" onClick={() => onDelete(cuenta)} title="Eliminar">&times;</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="pct-tree">
      {tree.map((node) => (
        <PlanCuentasTreeNode
          key={node.id}
          node={node}
          onCreateChild={onCreateChild}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default PlanCuentasTree;
